import React, { useState } from 'react';
import Loading from 'ui/components/v2/Loading';
import { useAppSelector } from '~/hooks/useAppSelector';

export const InsightPosthog: React.FC = () => {
  const { embedUrl } = useAppSelector(({ insightPosthog }) => insightPosthog);
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      {isLoading && <Loading />}
      <iframe
        style={{
          border: 0,
          transition: 'opacity 0.3s ease-in-out',
        }}
        width="100%"
        height="100%"
        allowFullScreen
        src={embedUrl}
        key="0"
        onLoad={() => setIsLoading(false)}
      />
    </div>
  );
};
